import { RouteLocationRaw } from 'vue-router'

export interface BButtonProps {
	/** Creates an icon component after default content in the append slot  */
	appendIcon?: string
	/** Creates an icon component in the prepend slot before default content */
	prependIcon?: string
	/** apply a specific icon and remove text from button */
	icon?: string
	/** specify content text for the component */
	text?: string
	/** specify button variant */
	variant?: 'filled' | 'outline' | 'link' | 'tonal'
	/** specify vue-router route */
	to?: string | RouteLocationRaw
	/** call router.replace() instead of router.push() when clicked */
	replace?: boolean
	/** designates the component as anchor and applies the href attribute */
	href?: string
	/** specify url or vue-router route target */
	target?: string
	/** exactly match the link. Without this, ‘/’ will match every route */
	exact?: boolean
	/** specify button size */
	size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
	/** Color of the Button, can be a color name from ui-kit like: primary, on-surface or hex. */
	color?: string
	/** Text color of the Button, it must be hex. */
	textColor?: string
	/** expands the button to 100% of available space */
	block?: boolean
	/** removes the ability to click or target the component */
	disabled?: boolean
	/** displays a progress bar and make button disabled */
	loading?: boolean
	/** specify button type */
	type?: 'submit' | 'button' | 'reset'
}

export interface BButtonEvents {
	click: [$event: MouseEvent]
}

export interface BButtonSlots {
	/** default slot */
	default?: () => unknown
	/**  adds an item inside the button and after button content */
	prepend?: () => unknown
	/** adds an item inside the button and before button content */
	append?: () => unknown
	/** slot for custom loading (displays only if loading prop is equal to true) */
	loading?: () => unknown
}

export const buttonSizeSetting = {
	xs: 'h-[2.125rem] text-body-1 py-2 px-3',
	sm: 'h-[2.25rem] text-label-1 py-2 px-3',
	base: 'h-[2.5rem] text-label-1 py-2.5 px-5',
	lg: 'h-[3rem] text-label-2 py-3 px-5',
	xl: 'h-[3.25rem] text-label-2 py-3.5 px-6'
}

export const iconButtonSizeSetting = {
	xs: 'p-[3px]',
	sm: 'p-[7px]',
	base: 'p-[9px]',
	lg: 'p-[13px]',
	xl: 'p-[15px]'
}
